import Vue from 'vue';
import App from './app.vue';
import iView from 'iview';
import { router } from './router/index';
import 'famfamfam-flags/dist/sprite/famfamfam-flags.css';
import '@/styles/theme.less';
import Ajax from './lib/ajaxCommon';
import AjaxAuth from '@/lib/ajaxAuth';
import util from './lib/util';
import store from './store/index';
import { appRouters } from './router/router';
import AppConst from '@/lib/appConst'
import Lazyload from 'vue-lazyload';
import meta from '@/lib/meta';
import waterfall from '@/components/waterfall/index.js';
import '@/lib/extensions.js';
import SignalRAspNetCoreHelper from '@/lib/SignalRAspNetCoreHelper';
import Loading from '@/components/loading/index.js';

Vue.use(iView);
Vue.config.productionTip = false;
Vue.use(meta);
Vue.use(waterfall);
Vue.use(Loading);

if (!abp.utils.getCookieValue('.Localization.CultureName')) {
  let language = navigator.language;
  abp.utils.setCookieValue('.Localization.CultureName', language, new Date(new Date().getTime() + 5 * 365 * 86400000), abp.appPath);
}

const tenancyName = util.getTenancyName();

AjaxAuth.post('/Account/IsTenantAvailable', { tenancyName: tenancyName }).then(resp => {
  const tenant = resp.data.result;
  util.abp = util.extend(true, util.abp, tenant.configuration);

  // clear configuration、vendor, etc. for cookie.
  tenant.configuration = undefined;
  tenant.vendor = undefined;
  tenant.platformOwnedVendor = undefined;

  util.abp.multiTenancy.setTenantIdCookie(tenant.tenantId);
  util.abp.multiTenancy.setTenantCookie(tenant);

  useLazyload(tenant);

  new Vue({
    render: h => h(App),
    router: router,
    store: store,
    data: {},

    created() {
      this.baidu();

      let tagsList: Array<any> = [];
      appRouters.map((item) => {
        if (item.children.length <= 1) {
          tagsList.push(item.children[0]);
        } else {
          tagsList.push(...item.children);
        }
      });
    },

    mounted() {
      util.checkDevice();

      // 添加事件监听器
      window.addEventListener('resize', () => {
        util.checkDevice();
      });

      this.$store.dispatch({ type: 'session/init' });
      this.$store.commit('app/initCachepage');

      SignalRAspNetCoreHelper.initSignalR();

      this.$Message.config({
        top: 100,
        duration: 8
      });
    },
    methods: {
      /**
       * 百度统计
      */
      baidu() {
        var _hmt = _hmt || [];
        (function () {
          var hm = document.createElement("script");
          hm.src = "https://hm.baidu.com/hm.js?fabe546abe9a9756aa3c3d53a806b232";
          var s = document.getElementsByTagName("script")[0];
          s.parentNode.insertBefore(hm, s);
        })();
      }
    }
  }).$mount('#app')
});

/**
 * 注册懒加载组件
*/
const useLazyload = (tenant) => {
  let noImage = 'img/img-error.png';

  if (tenant.logo2ImageUrl) {
    noImage = tenant.logo2ImageUrl;
  }

  Vue.use(Lazyload, {
    preLoad: 1.3,
    error: noImage,
    loading: 'img/img-loading.png',
    attempt: 1
  });
}